import { buildFakeRevJetLeaderboard, buildRevJetBanner, buildRevJetBannerMock } from './revjet';
import { getQueryParams } from './requestUrlHelpers';
import { get } from './axios';
import {
  getUrlParams,
  getMockPlaData,
  isBrandFpn,
  haveProductsChanged,
  triggerNewRelicTimeLog,
  isValidRequest,
  triggerNewRelic,
  getAdTypeFromParams,
} from './helpers';
import { newRelicConstants } from '../constants';

export const shouldMakeApiRequest = ({ lastRequestScenario, experienceContext, pageContext, customRenderId }) => {
  if (isBrandFpn({ experienceContext, pageContext })) {

    return false;
  }

  const currentUrl = window.location.pathname + window.location.search;

  if (lastRequestScenario.url !== currentUrl) {

    if (pageContext?.isCategory || pageContext?.isPip || pageContext?.isStorePage) {
      return true;
    }

    if (haveProductsChanged({ lastRequestScenario, pageContext })) {
      return true;
    }
  }
  // we know this is from educational layout
  // so return true
  if (customRenderId) return true;

  return false;
};

export const isValidLeaderboardScenario = ({
  browserId, schemaId, lastRequestScenario, experienceContext, pageContext, channel
}) => {

  const validSchemaIds = ['browse_sponsored__leaderboard', 'search_sponsored__leaderboard'];
  if (channel !== 'desktop'
     || !browserId
     || pageContext?.isPLP !== true
     || !validSchemaIds.includes(schemaId)
     || isBrandFpn({ experienceContext, pageContext })) {
    return false;
  }

  const currentUrl = window.location.pathname + window.location.search;
  if (lastRequestScenario.url !== currentUrl) {

    if (pageContext?.isPLP) {
      return true;
    }

    if (haveProductsChanged({ lastRequestScenario, pageContext })) {
      return true;
    }
  }
  return false;

};

export const makeApiRequest = async (requestConfig) => {
  // params is only for mock testing
  const params = getUrlParams(window.location.href);
  if (params.mockSponsoredBannerId) {
    requestConfig.setHasData(true);
    buildRevJetBannerMock(requestConfig);
  } else if (params.mockPlaSku) {
    requestConfig.setAdProducts(getMockPlaData(params.mockPlaSku));
  } else {
    // makes valid api call
    const queryParams = getQueryParams(requestConfig);
    if (isValidRequest(queryParams)) {
      try {

        const response = await get({ params: queryParams });

        const { data, status } = response;
        const adType = getAdTypeFromParams(queryParams);
        triggerNewRelic(adType, `API-${status}`);

        if (data) {
          if (data.customerRecentlyViewedSkus) {
            localStorage.setItem('retailMediaRecentlyViewedSku', JSON.stringify(...data.customerRecentlyViewedSkus.skus));
            let refreshAtDate = new Date().getTime() + data.customerRecentlyViewedSkus.refreshAt;
            localStorage.setItem('retailMediaRecentlyViewedSkuRefreshAt', refreshAtDate);
          }
          if (requestConfig.carouselType) {
            requestConfig.setAdProducts(data.products);
            if (requestConfig.setPageId) {
              requestConfig.setPageId(data.pageId);
            }
          } else {
            requestConfig.setHasData(true);
            if (requestConfig.startTime !== undefined) {
              triggerNewRelicTimeLog(newRelicConstants.STANDARD_BANNER_API_RESPONSE,
                requestConfig.startTime,
                Date.now());
            }
            buildRevJetBanner({ data, requestConfig });
          }
        }
        if ((!data || data?.products?.length <= 0 || status === 204)) {
          if (requestConfig.onNoSponsoredProducts) {
            requestConfig.onNoSponsoredProducts(true);
          }
          if (requestConfig.setRequestHelperError) {
            requestConfig.setRequestHelperError(true);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('ERROR: Could not make api request', error);
        if (requestConfig.onNoSponsoredProducts) {
          requestConfig.onNoSponsoredProducts(true);
        }
        if (requestConfig.setRequestHelperError) {
          requestConfig.setRequestHelperError(true);
        }
      }

    }
  }
};

// Delete function after leaderboard backend is complete
/* istanbul ignore next */
export const makeFakeApiRequest = async (requestConfig) => {

  const data = {
    banner: {
      bannerURL: '//rma.homedepot.com/tag233657-eg35038?adkey=2ec&sku=206391087&pub_ref=eyJ0YWdfZXh0IjoiZWczNTAzOCIsImQiOiJodG1sIn0=',
      clickthruURL: 'https://rma.homedepot.com/click/tag233657-eg35038-crv112606/null/1?adkey=2ec&lp=https://www.homedepot.com/b/MOEN/N-5yc1vZ3zb',
      // eslint-disable-next-line max-len
      onClickBeacon: 'https://ad-thd-sandbox.tagdelivery.com/click?id=5fa16880-dfba-4710-86ec-647550a3851f&x=n-_8PiE9rVCL3u33WqKVM_ysNAz_XRUN0TknlhQ_eGgRNruvfBovP60uryR-Pd_4FiLs0soKz7OQdYAwz1JQJHK5JeXqSPsmthHdCk7kqc3JrUJ7IoSkOyEem9Ne6E0HLem4UzpdHZSx79EeygxsmuUeHhbEU_8VyF6tUhVE7_agf4ywBiOn4CRg0jRgGHx8Fe0epbFnT_GPXoE5OL2sv_Q_dnS6YeLXssry7jAzSduUlNK3hs8xQQAYWZN75QWuih7L7W8BczGPI4jNotkJc6B_IEkqHftqXn9SNSsWmfB4OMKuwi6veXfsaLlXaoBTCPNWsrvpnagtm8UUjkDkIBdKINTiiBg3CpTgXjCQraPdBb4gyQEzNSVJGeLkueHmFQC9sBV4IiheHMINamsFazimSBVumJPo1ydx9KetpcfNZ7SGCHtnlXcU3zRotuT55Fhfrun_sE8gQz8hBMTD7xqMa-NafgfUvIT1Mv-sfRa-S56OxAZBOaEbcXWranRIMTU8kq8n452o2VpR0FamSw%3D%3D&redirect=',

      // eslint-disable-next-line max-len
      onViewBeacon: 'https://ad-thd-sandbox.tagdelivery.com/impression?id=5fa16880-dfba-4710-86ec-647550a3851f&x=n-_8PiE9rVCL3u33WqKVM_ysNAz_XRUN0TknlhQ_eGgRNruvfBovP60uryR-Pd_4FiLs0soKz7OQdYAwz1JQJHK5JeXqSPsmthHdCk7kqc3JrUJ7IoSkOyEem9Ne6E0HLem4UzpdHZSx79EeygxsmuUeHhbEU_8VyF6tUhVE7_agf4ywBiOn4CRg0jRgGHx8Fe0epbFnT_GPXoE5OL2sv_Q_dnS6YeLXssry7jAzSduUlNK3hs8xQQAYWZN75QWuih7L7W8BczGPI4jNotkJc6B_IEkqHftqXn9SNSsWmfB4OMKuwi6veXfsaLlXaoBTCPNWsrvpnagtm8UUjkDkIBdKINTiiBg3CpTgXjCQraPdBb4gyQEzNSVJGeLkueHmFQC9sBV4IiheHMINamsFazimSBVumJPo1ydx9KetpcfNZ7SGCHtnlXcU3zRotuT55Fhfrun_sE8gQz8hBMTD7xqMa-NafgfUvIT1Mv-sfRa-S56OxAZBOaEbcXWranRIMTU8kq8n452o2VpR0FamSw%3D%3D',
      slotId: 12660,
      campaignId: '306164',
      placementId: '29'

    }
  };

  if (data) {
    if (data.customerRecentlyViewedSkus) {
      localStorage.setItem('retailMediaRecentlyViewedSku', JSON.stringify(...data.customerRecentlyViewedSkus.skus));
      let refreshAtDate = new Date().getTime() + data.customerRecentlyViewedSkus.refreshAt;
      localStorage.setItem('retailMediaRecentlyViewedSkuRefreshAt', refreshAtDate);
    }
    if (requestConfig.carouselType) {
      requestConfig.setAdProducts(data.products);
      if (requestConfig.setPageId) {
        requestConfig.setPageId(data.pageId);
      }
    } else {
      requestConfig.setHasData(true);
      buildFakeRevJetLeaderboard(requestConfig);
    }
  }

};
